import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/styles/bootstrap.custom.css";
import "./assets/styles/index.css";
import "./index.css";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";

import { HelmetProvider } from "react-helmet-async";
import { Provider, useSelector } from "react-redux";
import store from "./store";

// Public Screens
import LoginScreen from "./screens/LoginScreen";
import HomeScreen from "./screens/HomeScreen";
import ChangePasswordScreen from "./screens/ChangePasswordScreen";
import Unauthorized from "./screens/Unauthorized";

// Coaching Center Screens
import CoachingCenterDetailsScreen from "./screens/coachingCenter/CoachingCenterDetailsScreen";
import CoachingCenterEditScreen from "./screens/coachingCenter/CoachingCenterEditScreen";
import CoachingCenterListScreen from "./screens/coachingCenter/CoachingCenterListScreen";
import CreateCoachingCenterScreen from "./screens/coachingCenter/CreateCoachingCenterScreen";

// Question Bank Subject Screens
import QuestionBankSubjectCreateScreen from "./screens/questionBankSubject/QuestionBankSubjectCreateScreen";
import QuestionBankSubjectDetailsScreen from "./screens/questionBankSubject/QuestionBankSubjectDetailsScreen";
import QuestionBankSubjectEditScreen from "./screens/questionBankSubject/QuestionBankSubjectEditScreen";
import QuestionBankSubjectListScreen from "./screens/questionBankSubject/QuestionBankSubjectListScreen";

// Chapter Screens
import ChapterDetailsScreen from "./screens/chapter/ChapterDetailsScreen";
import ChapterListScreen from "./screens/chapter/ChapterListScreen";
import CreateChapterScreen from "./screens/chapter/CreateChapterScreen";
import EditChapterScreen from "./screens/chapter/EditChapterScreen";

// Question Screens
import CreateQuestionScreen from "./screens/question/CreateQuestionScreen";
import QuestionDetailsScreen from "./screens/question/QuestionDetailsScreen";
import QuestionEditScreen from "./screens/question/QuestionEditScreen";
import QuestionListScreen from "./screens/question/QuestionListScreen";

// Quiz Question Screens
import QuizQuestionCreateScreen from "./screens/quizQuestion/QuizQuestionCreateScreen";
import QuizQuestionDetailsScreen from "./screens/quizQuestion/QuizQuestionDetailsScreen";
import QuizQuestionEditScreen from "./screens/quizQuestion/QuizQuestionEditScreen";
import QuizQuestionListScreen from "./screens/quizQuestion/QuizQuestionListScreen";
import QuizQuestionRemoveScreen from "./screens/quizQuestion/QuizQuestionRemoveScreen";

// Quiz Screens
import CreateQuizScreen from "./screens/quiz/CreateQuizScreen";
import QuizDetailsScreen from "./screens/quiz/QuizDetailsScreen";
import QuizEditScreen from "./screens/quiz/QuizEditScreen";
import QuizListScreen from "./screens/quiz/QuizListScreen";

// Quiz Attempt Screens
import MyAttemptsScreen from "./screens/quizAttempt/MyAttemptsScreen";
import QuizAttemptReportScreen from "./screens/quizAttempt/QuizAttemptReportScreen";
import QuizResultScreen from "./screens/quizAttempt/QuizResultScreen";
import QuizAttemptLoader from "./screens/quizAttempt/components/QuizAttemptLoader";
import AdminQuizAttempts from "./screens/quizAttempt/AdminQuizAttempts";
import QuizAttemptDetails from "./screens/quizAttempt/QuizAttemptDetails";
import CenterDashboardScreen from "./screens/quizAttempt/CenterDashboardScreen";

// Quiz Attempt Screens
// import QuizAttemptScreen from "./screens/studentQuiz/QuizAttemptScreen";
import StudentQuizListScreen from "./screens/studentQuiz/StudentQuizListScreen";
import StudentQuizStartScreen from "./screens/studentQuiz/StudentQuizStartScreen";

// Quiz Attempt Screens
import CreateQuizBlueprint from "./screens/quizBlueprint/CreateQuizBlueprint";
import EditQuizBlueprint from "./screens/quizBlueprint/EditQuizBlueprint";
import QuizBlueprintStatisticsScreen from "./screens/quizBlueprint/QuizBlueprintStatisticsScreen";

// Quiz Generation Screens
import GenerateQuestionPaperScreen from "./screens/quizGeneration/GenerateQuestionPaperScreen";

// Quiz Image Management
import QuizImageManagementScreen from "./screens/quizImageManagement/QuizImageManagementScreen";
import ExcelUploadScreen from "./screens/excelUpload/ExcelUploadScreen";

// Billing Screens
import CoachingCenterBillingSettingsScreen from "./screens/billing/CoachingCenterBillingSettingsScreen";
import GenerateInvoiceScreen from "./screens/billing/GenerateInvoiceScreen";
import InvoiceDetailsScreen from "./screens/billing/InvoiceDetailsScreen";
import InvoiceListScreen from "./screens/billing/InvoiceListScreen";
import InvoiceRegenerateScreen from "./screens/billing/InvoiceRegenerateScreen";
import CoachingCenterInvoices from "./screens/billing/CoachingCenterInvoices";
import CoachingCenterInvoiceDetails from "./screens/billing/CoachingCenterInvoiceDetails";

// Billing Dashboard Screens
import BillingDashboardScreen from "./screens/billingDashboard/BillingDashboardScreen";
import CoachingCenterBillingHistoryScreen from "./screens/billingDashboard/CoachingCenterBillingHistoryScreen";
import MonthlyRevenueScreen from "./screens/billingDashboard/MonthlyRevenueScreen";
import OutstandingInvoicesScreen from "./screens/billingDashboard/OutstandingInvoicesScreen";

// English Question Bank Screens
import EnglishQuestionGroupCreate from "./screens/englishQuestionsGroup/EnglishQuestionGroupCreate";
import EnglishQuestionGroupDetails from "./screens/englishQuestionsGroup/EnglishQuestionGroupDetails";
import EnglishQuestionGroupEdit from "./screens/englishQuestionsGroup/EnglishQuestionGroupEdit";
import EnglishQuestionGroupList from "./screens/englishQuestionsGroup/EnglishQuestionGroupList";

// English Question Screens
import EnglishQuestionCreate from "./screens/englishQuestions/EnglishQuestionCreate";
import EnglishQuestionDetails from "./screens/englishQuestions/EnglishQuestionDetails";
import EnglishQuestionEdit from "./screens/englishQuestions/EnglishQuestionEdit";
import EnglishQuestionList from "./screens/englishQuestions/EnglishQuestionList";

// English Quiz Screens
import EnglishQuizCreate from "./screens/englishquiz/EnglishQuizCreate";
import EnglishQuizDetails from "./screens/englishquiz/EnglishQuizDetails";
import EnglishQuizEdit from "./screens/englishquiz/EnglishQuizEdit";
import EnglishQuizList from "./screens/englishquiz/EnglishQuizList";
import EnglishQuizStatistics from "./screens/englishquiz/EnglishQuizStatistics";

// English Quiz BluePrint Screens
import EnglishQuizBlueprintAvailability from "./screens/englishquizBlueprint/EnglishQuizBlueprintAvailability";
import EnglishQuizBlueprintCreate from "./screens/englishquizBlueprint/EnglishQuizBlueprintCreate";
import EnglishQuizBlueprintDetails from "./screens/englishquizBlueprint/EnglishQuizBlueprintDetails";
import EnglishQuizBlueprintEdit from "./screens/englishquizBlueprint/EnglishQuizBlueprintEdit";
import EnglishQuizBlueprintValidation from "./screens/englishquizBlueprint/EnglishQuizBlueprintValidation";

// English Quiz Attempt Screens
import EnglishQuizAttemptDetailsScreen from "./screens/englishquizattempt/EnglishQuizAttemptDetailsScreen";
import EnglishQuizAttemptListScreen from "./screens/englishquizattempt/EnglishQuizAttemptListScreen";
import EnglishQuizAttemptScreen from "./screens/englishquizattempt/EnglishQuizAttemptScreen";
import EnglishQuizResultScreen from "./screens/englishquizattempt/EnglishQuizResultScreen";
import EnglishQuizStartScreen from "./screens/englishquizattempt/EnglishQuizStartScreen";
import EnglishQuizAttemptDetailsAdminScreen from "./screens/englishquizattempt/admin/EnglishQuizAttemptDetailsAdminScreen";
import EnglishQuizAttemptsAdminScreen from "./screens/englishquizattempt/admin/EnglishQuizAttemptsAdminScreen";
// Admin Screens
import UserListScreen from "./screens/admin/UserListScreen";
import UserEditScreen from "./screens/admin/UserEditScreen";
import CreateUserScreen from "./screens/admin/CreateUserScreen";
import ForgotPasswordRequests from "./screens/admin/ForgotPasswordRequests";

// Route Guards
import AdminRoute from "./components/AdminRoute";
import ProductAdminRoute from "./components/ProductAdminRoute";
import StudentRoute from "./components/StudentRoute";
import CenterAdminRoute from "./components/CenterAdminRoute";

const RouterWrapper = () => {
  const { userInfo } = useSelector((state) => state.auth);

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path="/" element={<App />}>
        {/* PUBLIC ROUTES */}
        <Route index element={<LoginScreen />} />
        <Route path="/home" element={<HomeScreen />} />
        
        <Route path="/change-password" element={<ChangePasswordScreen />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        {/* PRODUCT ADMIN ONLY - COACHING CENTERS */}
        <Route
          path="/coaching-centers"
          element={
            <ProductAdminRoute user={userInfo}>
              <CoachingCenterListScreen />
            </ProductAdminRoute>
          }
        />
        <Route
          path="/coaching-centers/create"
          element={
            <ProductAdminRoute user={userInfo}>
              <CreateCoachingCenterScreen />
            </ProductAdminRoute>
          }
        />
        <Route
          path="/coaching-centers/:id"
          element={
            <ProductAdminRoute user={userInfo}>
              <CoachingCenterDetailsScreen />
            </ProductAdminRoute>
          }
        />
        <Route
          path="/coaching-centers/:id/edit"
          element={
            <ProductAdminRoute user={userInfo}>
              <CoachingCenterEditScreen />
            </ProductAdminRoute>
          }
        />
        {/* ======================================================
    USER MANAGEMENT - CENTER ADMIN ONLY
====================================================== */}

{/* User List */}
<Route
  path="/users"
  element={
    <CenterAdminRoute user={userInfo}>
      <UserListScreen />
    </CenterAdminRoute>
  }
/>

{/* Create Student / Center Admin */}
<Route
  path="/users/create"
  element={
    <CenterAdminRoute user={userInfo}>
      <CreateUserScreen />
    </CenterAdminRoute>
  }
/>

<Route
  path="/users/forgot-password-requests"
  element={
    <CenterAdminRoute user={userInfo}>
      <ForgotPasswordRequests />
    </CenterAdminRoute>
  }
/>

{/* Edit User */}
<Route
  path="/users/:id/edit"
  element={
    <CenterAdminRoute user={userInfo}>
      <UserEditScreen />
    </CenterAdminRoute>
  }
/>
        {/* QUESTION BANK SUBJECTS - PRODUCT ADMIN + CENTER ADMIN */}
        <Route
          path="/question-bank-subjects"
          element={
            <ProductAdminRoute user={userInfo}>
              <QuestionBankSubjectListScreen />
            </ProductAdminRoute>
          }
        />
        <Route
          path="/question-bank-subjects/create"
          element={
            <ProductAdminRoute user={userInfo}>
              <QuestionBankSubjectCreateScreen />
            </ProductAdminRoute>
          }
        />
        <Route
          path="/question-bank-subjects/:id"
          element={
            <ProductAdminRoute user={userInfo}>
              <QuestionBankSubjectDetailsScreen />
            </ProductAdminRoute>
          }
        />
        <Route
          path="/question-bank-subjects/:id/edit"
          element={
            <ProductAdminRoute user={userInfo}>
              <QuestionBankSubjectEditScreen />
            </ProductAdminRoute>
          }
        />
        {/* CHAPTERS */}
        <Route
          path="/chapters"
          element={
            <ProductAdminRoute user={userInfo}>
              <ChapterListScreen />
            </ProductAdminRoute>
          }
        />
        <Route
          path="/chapters/create"
          element={
            <ProductAdminRoute user={userInfo}>
              <CreateChapterScreen />
            </ProductAdminRoute>
          }
        />
        <Route
          path="/chapters/:id"
          element={
            <ProductAdminRoute user={userInfo}>
              <ChapterDetailsScreen />
            </ProductAdminRoute>
          }
        />
        <Route
          path="/chapters/:id/edit"
          element={
            <ProductAdminRoute user={userInfo}>
              <EditChapterScreen />
            </ProductAdminRoute>
          }
        />
        {/* ENGLISH QUESTION GROUPS - PRODUCT ADMIN ONLY */}
        <Route
          path="/english-question-groups"
          element={
            <ProductAdminRoute user={userInfo}>
              <EnglishQuestionGroupList />
            </ProductAdminRoute>
          }
        />
        {/* ======================================================
    ENGLISH QUESTIONS
    Product Admin + Center Admin: View
    Product Admin: Create / Edit
====================================================== */}
        {/* English Question List */}
        <Route
          path="/english-questions"
          element={
            <ProductAdminRoute user={userInfo}>
              <EnglishQuestionList />
            </ProductAdminRoute>
          }
        />
        {/* Create English Question - Product Admin Only */}
        <Route
          path="/english-questions/create"
          element={
            <ProductAdminRoute user={userInfo}>
              <EnglishQuestionCreate />
            </ProductAdminRoute>
          }
        />
        {/* English Question Details - Product Admin + Center Admin */}
        <Route
          path="/english-questions/:id"
          element={
            <ProductAdminRoute user={userInfo}>
              <EnglishQuestionDetails />
            </ProductAdminRoute>
          }
        />
        {/* Edit English Question - Product Admin Only */}
        <Route
          path="/english-questions/:id/edit"
          element={
            <ProductAdminRoute user={userInfo}>
              <EnglishQuestionEdit />
            </ProductAdminRoute>
          }
        />
        <Route
          path="/english-question-groups/create"
          element={
            <ProductAdminRoute user={userInfo}>
              <EnglishQuestionGroupCreate />
            </ProductAdminRoute>
          }
        />
        <Route
          path="/english-question-groups/:id"
          element={
            <ProductAdminRoute user={userInfo}>
              <EnglishQuestionGroupDetails />
            </ProductAdminRoute>
          }
        />
        <Route
          path="/english-question-groups/:id/edit"
          element={
            <ProductAdminRoute user={userInfo}>
              <EnglishQuestionGroupEdit />
            </ProductAdminRoute>
          }
        />
        {/* QUESTIONS - PRODUCT ADMIN + CENTER ADMIN */}
        <Route
          path="/quizzes/:quizId/questions"
          element={
            <ProductAdminRoute user={userInfo}>
              <QuestionListScreen />
            </ProductAdminRoute>
          }
        />
        <Route
          path="/questions/create"
          element={
            <ProductAdminRoute user={userInfo}>
              <CreateQuestionScreen />
            </ProductAdminRoute>
          }
        />
        <Route
          path="/questions/:id"
          element={
            <ProductAdminRoute user={userInfo}>
              <QuestionDetailsScreen />
            </ProductAdminRoute>
          }
        />
        <Route
          path="/questions/:id/edit"
          element={
            <ProductAdminRoute user={userInfo}>
              <QuestionEditScreen />
            </ProductAdminRoute>
          }
        />
        {/* QUIZZES - CENTER ADMIN ONLY */}
        <Route
          path="/dashboard"
          element={
            <CenterAdminRoute user={userInfo}>
              <CenterDashboardScreen />
            </CenterAdminRoute>
          }
        />
        <Route
          path="/quizzes"
          element={
            <CenterAdminRoute user={userInfo}>
              <QuizListScreen />
            </CenterAdminRoute>
          }
        />
        <Route
          path="/quizzes/create"
          element={
            <CenterAdminRoute user={userInfo}>
              <CreateQuizScreen />
            </CenterAdminRoute>
          }
        />
        <Route
          path="/quizzes/:id"
          element={
            <CenterAdminRoute user={userInfo}>
              <QuizDetailsScreen />
            </CenterAdminRoute>
          }
        />
        <Route
          path="/quizzes/:id/edit"
          element={
            <CenterAdminRoute user={userInfo}>
              <QuizEditScreen />
            </CenterAdminRoute>
          }
        />
        {/* QUIZ BLUEPRINT */}
        <Route
          path="/quizzes/:quizId/blueprint"
          element={
            <CenterAdminRoute user={userInfo}>
              <CreateQuizBlueprint />
            </CenterAdminRoute>
          }
        />
        <Route
          path="/quizzes/:quizId/blueprint/create"
          element={
            <CenterAdminRoute user={userInfo}>
              <CreateQuizBlueprint />
            </CenterAdminRoute>
          }
        />
        <Route
          path="/quizzes/:quizId/blueprint/edit"
          element={
            <CenterAdminRoute user={userInfo}>
              <EditQuizBlueprint />
            </CenterAdminRoute>
          }
        />
        <Route
          path="/quizzes/:id/blueprint/statistics"
          element={
            <CenterAdminRoute user={userInfo}>
              <QuizBlueprintStatisticsScreen />
            </CenterAdminRoute>
          }
        />
        <Route
          path="/billing/coaching-center/invoices"
          element={
            <CenterAdminRoute user={userInfo}>
              <CoachingCenterInvoices />
            </CenterAdminRoute>
          }
        />
        <Route
          path="/billing/coaching-center/invoices/:invoiceId"
          element={
            <CenterAdminRoute user={userInfo}>
              <CoachingCenterInvoiceDetails />
            </CenterAdminRoute>
          }
        />
        {/* QUESTION PAPER GENERATION */}
        <Route
          path="/quizzes/:quizId/generate"
          element={
            <CenterAdminRoute user={userInfo}>
              <GenerateQuestionPaperScreen />
            </CenterAdminRoute>
          }
        />
        {/* QUIZ QUESTION MAPPING - CENTER ADMIN ONLY */}
        <Route
          path="/quiz-questions"
          element={
            <CenterAdminRoute user={userInfo}>
              <QuizQuestionListScreen />
            </CenterAdminRoute>
          }
        />
        <Route
          path="/quiz-questions/quiz/:quizId"
          element={
            <CenterAdminRoute user={userInfo}>
              <QuizQuestionListScreen />
            </CenterAdminRoute>
          }
        />
        <Route
          path="/quiz-attempts"
          element={
            <CenterAdminRoute user={userInfo}>
              <AdminQuizAttempts />
            </CenterAdminRoute>
          }
        />
        <Route
          path="/admin/quiz-attempts/:attemptId"
          element={
            <CenterAdminRoute user={userInfo}>
              <QuizAttemptDetails />
            </CenterAdminRoute>
          }
        />
        <Route
          path="/quiz-questions/create"
          element={
            <CenterAdminRoute user={userInfo}>
              <QuizQuestionCreateScreen />
            </CenterAdminRoute>
          }
        />
        <Route
          path="/quiz-questions/:id"
          element={
            <CenterAdminRoute user={userInfo}>
              <QuizQuestionDetailsScreen />
            </CenterAdminRoute>
          }
        />
        <Route
          path="/quiz-questions/:id/edit"
          element={
            <CenterAdminRoute user={userInfo}>
              <QuizQuestionEditScreen />
            </CenterAdminRoute>
          }
        />
        <Route
          path="/quiz-questions/:id/remove"
          element={
            <CenterAdminRoute user={userInfo}>
              <QuizQuestionRemoveScreen />
            </CenterAdminRoute>
          }
        />
        {/* QUIZ ATTEMPT REPORT - CENTER ADMIN ONLY */}
        <Route
          path="/quiz-attempts/quiz/:quizId"
          element={
            <CenterAdminRoute user={userInfo}>
              <QuizAttemptReportScreen />
            </CenterAdminRoute>
          }
        />
        {/* EXCEL UPLOAD - PRODUCT ADMIN + CENTER ADMIN */}
        <Route
          path="/excel-upload"
          element={
            <ProductAdminRoute user={userInfo}>
              <ExcelUploadScreen />
            </ProductAdminRoute>
          }
        />
        jsx
        {/* ======================================================
    BILLING MANAGEMENT - PRODUCT ADMIN ONLY
    ====================================================== */}
        {/* Coaching Center Billing Settings */}
        <Route
          path="/billing/settings/:coachingCenterId"
          element={
            <ProductAdminRoute user={userInfo}>
              <CoachingCenterBillingSettingsScreen />
            </ProductAdminRoute>
          }
        />
        {/* Invoice List */}
        <Route
          path="/billing/invoices"
          element={
            <ProductAdminRoute user={userInfo}>
              <InvoiceListScreen />
            </ProductAdminRoute>
          }
        />
        {/* Generate Invoice */}
        <Route
          path="/billing/invoices/generate"
          element={
            <ProductAdminRoute user={userInfo}>
              <GenerateInvoiceScreen />
            </ProductAdminRoute>
          }
        />
        {/* Invoice Details */}
        <Route
          path="/billing/invoices/:invoiceId"
          element={
            <ProductAdminRoute user={userInfo}>
              <InvoiceDetailsScreen />
            </ProductAdminRoute>
          }
        />
        {/* Regenerate Invoice */}
        <Route
          path="/billing/invoices/:invoiceId/regenerate"
          element={
            <ProductAdminRoute user={userInfo}>
              <InvoiceRegenerateScreen />
            </ProductAdminRoute>
          }
        />
        jsx
        {/* ======================================================
    BILLING DASHBOARD - PRODUCT ADMIN ONLY
====================================================== */}
        {/* Billing Dashboard */}
        <Route
          path="/billing/dashboard"
          element={
            <ProductAdminRoute user={userInfo}>
              <BillingDashboardScreen />
            </ProductAdminRoute>
          }
        />
        {/* Coaching Center Billing History */}
        <Route
          path="/billing/dashboard/center/:centerId/history"
          element={
            <ProductAdminRoute user={userInfo}>
              <CoachingCenterBillingHistoryScreen />
            </ProductAdminRoute>
          }
        />
        {/* Monthly Revenue */}
        <Route
          path="/billing/dashboard/monthly-revenue"
          element={
            <ProductAdminRoute user={userInfo}>
              <MonthlyRevenueScreen />
            </ProductAdminRoute>
          }
        />
        {/* Outstanding Invoices */}
        <Route
          path="/billing/dashboard/outstanding"
          element={
            <ProductAdminRoute user={userInfo}>
              <OutstandingInvoicesScreen />
            </ProductAdminRoute>
          }
        />
        {/* QUIZ IMAGE MANAGEMENT - CENTER ADMIN ONLY */}
        <Route
          path="/quizzes/:quizId/images"
          element={
            <CenterAdminRoute user={userInfo}>
              <QuizImageManagementScreen />
            </CenterAdminRoute>
          }
        />
        // ====================================================== // ENGLISH
        QUIZ MANAGEMENT - CENTER ADMIN //
        ====================================================== // English Quiz
        List
        <Route
          path="/english-quizzes"
          element={
            <CenterAdminRoute user={userInfo}>
              <EnglishQuizList />
            </CenterAdminRoute>
          }
        />
        // Create English Quiz
        <Route
          path="/english-quizzes/create"
          element={
            <CenterAdminRoute user={userInfo}>
              <EnglishQuizCreate />
            </CenterAdminRoute>
          }
        />
        // English Quiz Statistics // IMPORTANT: Must come before "/:id"
        <Route
          path="/english-quizzes/:id/statistics"
          element={
            <CenterAdminRoute user={userInfo}>
              <EnglishQuizStatistics />
            </CenterAdminRoute>
          }
        />
        // English Quiz Details
        <Route
          path="/english-quizzes/:quizId"
          element={
            <CenterAdminRoute user={userInfo}>
              <EnglishQuizDetails />
            </CenterAdminRoute>
          }
        />
        // Edit English Quiz
        <Route
          path="/english-quizzes/:id/edit"
          element={
            <CenterAdminRoute user={userInfo}>
              <EnglishQuizEdit />
            </CenterAdminRoute>
          }
        />
        // ====================================================== // ENGLISH
        QUIZ BLUEPRINT MANAGEMENT - CENTER ADMIN ONLY //
        ====================================================== // Create / View
        English Quiz Blueprint
        {/* <Route
          path="/english-quizzes/:quizId/blueprint"
          element={
            <CenterAdminRoute user={userInfo}>
              <EnglishQuizBlueprintCreate />
            </CenterAdminRoute>
          }
        /> */}
        // Explicit Create English Quiz Blueprint
        <Route
          path="/english-quizzes/:quizId/blueprint/create"
          element={
            <CenterAdminRoute user={userInfo}>
              <EnglishQuizBlueprintCreate />
            </CenterAdminRoute>
          }
        />
        // English Quiz Blueprint Details
        <Route
          path="/english-quizzes/:id/blueprint"
          element={
            <CenterAdminRoute user={userInfo}>
              <EnglishQuizBlueprintDetails />
            </CenterAdminRoute>
          }
        />
        // Edit English Quiz Blueprint
        <Route
          path="/english-quizzes/:id/blueprint/edit"
          element={
            <CenterAdminRoute user={userInfo}>
              <EnglishQuizBlueprintEdit />
            </CenterAdminRoute>
          }
        />
        // Blueprint Availability
        <Route
          path="/english-quizzes/:id/blueprint/availability"
          element={
            <CenterAdminRoute user={userInfo}>
              <EnglishQuizBlueprintAvailability />
            </CenterAdminRoute>
          }
        />
        // Blueprint Validation
        <Route
          path="/english-quizzes/:id/blueprint/validate"
          element={
            <CenterAdminRoute user={userInfo}>
              <EnglishQuizBlueprintValidation />
            </CenterAdminRoute>
          }
        />
        {/* ======================================================
    ENGLISH QUIZ ATTEMPT ROUTES
====================================================== */}
        {/* ======================================================
    CENTER ADMIN
====================================================== */}
        {/* 
  Get all attempts for an English quiz

  Backend:
  GET /api/english-quizattempts/quiz/:quizId

  Access:
  centerAdmin
*/}
        <Route
          path="/admin/english-quiz-attempts/quiz/:quizId"
          element={
            <CenterAdminRoute user={userInfo}>
              <EnglishQuizAttemptsAdminScreen />
            </CenterAdminRoute>
          }
        />
        {/* 
  Get single English quiz attempt details

  Backend:
  GET /api/english-quizattempts/admin/:attemptId

  Access:
  centerAdmin
*/}
        <Route
          path="/admin/english-quiz-attempts/:attemptId"
          element={
            <CenterAdminRoute user={userInfo}>
              <EnglishQuizAttemptDetailsAdminScreen />
            </CenterAdminRoute>
          }
        />
        {/* ======================================================
    STUDENT
====================================================== */}
        {/* 
  Get my English quiz attempts

  Backend:
  GET /api/english-quizattempts/my

  Access:
  student
*/}
        <Route
          path="/english-quiz-attempts/my"
          element={
            <StudentRoute user={userInfo}>
              <EnglishQuizAttemptListScreen />
            </StudentRoute>
          }
        />
        {/* 
  Start English quiz

  Backend:
  POST /api/english-quizattempts/start/:quizId

  Access:
  student
*/}
        <Route
          path="/english-quizzes/:quizId/start"
          element={
            <StudentRoute user={userInfo}>
              <EnglishQuizStartScreen />
            </StudentRoute>
          }
        />
        {/* 
  Active / resumed English quiz attempt

  Backend:
  GET  /api/english-quizattempts/:attemptId/resume
  PUT  /api/english-quizattempts/:attemptId/submit

  Access:
  student

  EnglishQuizAttemptScreen handles the active attempt,
  including loading/resuming and submitting.
*/}
        <Route
          path="/english-quiz-attempts/:attemptId/attempt"
          element={
            <StudentRoute user={userInfo}>
              <EnglishQuizAttemptScreen />
            </StudentRoute>
          }
        />
        {/* 
  English quiz result

  Frontend screen for displaying the completed attempt.

  Access:
  student
*/}
        <Route
          path="/english-quiz-attempts/:attemptId/result"
          element={
            <StudentRoute user={userInfo}>
              <EnglishQuizResultScreen />
            </StudentRoute>
          }
        />
        {/* 
  Get my English quiz attempt

  Backend:
  GET /api/english-quizattempts/:attemptId

  Access:
  student
*/}
        <Route
          path="/english-quiz-attempts/:attemptId"
          element={
            <StudentRoute user={userInfo}>
              <EnglishQuizAttemptDetailsScreen />
            </StudentRoute>
          }
        />
        {/* STUDENT QUIZ ATTEMPT ROUTES */}
        <Route
          path="/quiz-attempts/my"
          element={
            <StudentRoute user={userInfo}>
              <MyAttemptsScreen />
            </StudentRoute>
          }
        />
        <Route
          path="/student/attempt/:attemptId"
          element={
            <StudentRoute user={userInfo}>
              <QuizAttemptLoader />
            </StudentRoute>
          }
        />
        <Route
          path="/quiz-attempts/:id"
          element={
            <StudentRoute user={userInfo}>
              <QuizResultScreen />
            </StudentRoute>
          }
        />
        {/* STUDENT QUIZ ROUTES */}
        <Route
          path="/student/quizzes"
          element={
            <StudentRoute user={userInfo}>
              <StudentQuizListScreen />
            </StudentRoute>
          }
        />
        <Route
          path="/student/quizzes/:quizId/start"
          element={
            <StudentRoute user={userInfo}>
              <StudentQuizStartScreen />
            </StudentRoute>
          }
        />
      </Route>,
    ),
  );

  return <RouterProvider router={router} />;
};

// Mount React App

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <RouterWrapper />
      </Provider>
    </HelmetProvider>
  </React.StrictMode>,
);

reportWebVitals();
